// T-181 (v1.8.57, Session 44, 05.10.2026): Gästekalender zeigt bei Terminen in Planung "ab n Personen buchbar" statt "auf Anfrage"
// (Kundin 05.10.2026 09:55, Erik-Entscheidung 05.10. abends: Zahl aus der Mindestteilnehmerzahl des Termins, sonst 30).
// Reine Funktionen, getestet in kalenderAnfrage.test.ts.

/** Ersatzwert, wenn der Termin keine brauchbare Mindestteilnehmerzahl trägt (z. B. 0, 1 oder leer). */
export const STANDARD_MINDEST_PERSONEN = 30;

interface MitMindestzahl {
  minCapacity?: number | null;
  minParticipants?: number | null;
}

const brauchbar = (n: unknown): n is number =>
  typeof n === 'number' && Number.isFinite(n) && Number.isInteger(n) && n >= 2;

/** Mindestpersonen eines Termins: minCapacity bzw. minParticipants, wenn ganzzahlig und mindestens 2, sonst 30. */
export function mindestPersonen(slot?: MitMindestzahl | null): number {
  if (!slot) return STANDARD_MINDEST_PERSONEN;
  if (brauchbar(slot.minCapacity)) return slot.minCapacity;
  if (brauchbar(slot.minParticipants)) return slot.minParticipants;
  return STANDARD_MINDEST_PERSONEN;
}

/** Mindestpersonen einer Zeitgruppe (mehrere Tourarten zur selben Uhrzeit): kleinste brauchbare Zahl, sonst 30. */
export function mindestPersonenGruppe(slots?: ReadonlyArray<MitMindestzahl | null | undefined> | null): number {
  const werte = (slots ?? [])
    .map(s => (s ? (brauchbar(s.minCapacity) ? s.minCapacity : brauchbar(s.minParticipants) ? s.minParticipants : null) : null))
    .filter((n): n is number => n !== null);
  return werte.length > 0 ? Math.min(...werte) : STANDARD_MINDEST_PERSONEN;
}

/** Anzeigetext für Kachel und Hinweise: "ab 30 Personen buchbar". */
export function anfrageText(n: number): string {
  return `ab ${n} Personen buchbar`;
}

/** Satz im Anfrage-Dialog. */
export function anfrageEinleitung(n: number): string {
  return `Dieser Termin ist in Planung und noch nicht online buchbar, er findet ab ${n} zahlenden Teilnehmern statt.`;
}
